import type { GPC } from 'api';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { CreatePerformanceMetricsCalibrationDataParams } from 'pages/Valuations/approaches/guidelineCalibration/performance_metrics/types';
import { RowConfigCalibrationParams } from '../rowConfig/types';

export interface CreateColumnsCalibrationParams {
  valuationsApproachGpc?: RowConfigCalibrationParams['valuationsApproachGpc'];
  financials: CreatePerformanceMetricsCalibrationDataParams['financials'];
  gpcComparisonByDate?: Array<GPC>;
}
export interface PerformanceMetricsColumnValue extends Pick<ICell, 'value'> {
  enabled?: boolean;
}
export interface PerformanceMetricsColumn {
  [key: string]: PerformanceMetricsColumnValue;
}
export const PERFORMANCE_METRICS_SPREADSHEET_COMPANY_LTM_REVENUE_MULTIPLE
   = 'performance_metrics_ltm_revenue_multiple_current_company';
export const PERFORMANCE_METRICS_SPREADSHEET_COMPANY_NTM_REVENUE_MULTIPLE
   = 'performance_metrics_ntm_revenue_multiple_current_company';
export const PERFORMANCE_METRICS_SPREADSHEET_COMPANY_LTM_EBITDA_MULTIPLE
   = 'performance_metrics_ltm_ebitda_multiple_current_company';
export const PERFORMANCE_METRICS_SPREADSHEET_COMPANY_NTM_EBITDA_MULTIPLE
   = 'performance_metrics_ntm_ebitda_multiple_current_company';
export const MULTIPLE_TYPES = [
  PERFORMANCE_METRICS_SPREADSHEET_COMPANY_LTM_REVENUE_MULTIPLE,
  PERFORMANCE_METRICS_SPREADSHEET_COMPANY_NTM_REVENUE_MULTIPLE,
  PERFORMANCE_METRICS_SPREADSHEET_COMPANY_LTM_EBITDA_MULTIPLE,
  PERFORMANCE_METRICS_SPREADSHEET_COMPANY_NTM_EBITDA_MULTIPLE,
];

export type CreateColumns = (params: CreateColumnsCalibrationParams) => PerformanceMetricsColumn[];
